import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import SigninView from '@/views/auth/SigninView'
import ErrorView from '@/views/404View'

import DashboardView from '@/views/navigation/DashboardView'
import PresenceView from '@/views/navigation/PresenceView'
import AccessView from '@/views/navigation/AccessView'
import ExceptionView from '@/views/navigation/ExceptionView'
import RequestView from '@/views/navigation/RequestView'
import EmployeeView from '@/views/navigation/EmployeeView'
import ZonesView from '@/views/navigation/ZonesView'
import DaysView from '@/views/navigation/DaysView'
import DepartementView from '@/views/navigation/DepartementView'
import ShiftsView from '@/views/navigation/ShiftsView'
import HomePage from "@/views/navigation/home-page.vue"
import MyException from "@/views/navigation/my-exception.vue"
import MyPermission from "@/views/navigation/my-permission.vue"
import MyTeam from "@/views/navigation/my-team.vue";
import DetailsMyTeam from "@/views/navigation/details-my-team.vue";
import ProfileVue from "@/views/navigation/profil-vue.vue";
import MyDemande from "@/views/navigation/my-demande.vue";
import MotifView from "@/views/navigation/motifView.vue";
import ResetPassword from "@/views/navigation/reset-password.vue";
import DocumentUi from "@/views/navigation/document-ui.vue";
import TaskView from '@/views/navigation/taskView.vue';
// import UpdateTask from '@/views/navigation/update-task.vue'
import CreateTaskView from '@/views/navigation/create-task-view.vue';
import UpdateTaskView from '@/views/navigation/update-task-view.vue';
import HrReview from '@/views/navigation/hr-review.vue'
import DetailHrReview from '@/views/navigation/detail-hr-review.vue'
import AttestDepartCongeMat from '@/views/navigation/template/attest-depart-conge-mat.vue'
import AttestStage from '@/views/navigation/template/attest-stage.vue'
import AttestTravail from '@/views/navigation/template/attest-travail.vue'
import DemandeConge from '@/views/navigation/template/demande-conge.vue'
import AttestConge from '@/views/navigation/template/uigb/attest-conge.vue'
import AttestConsultant from '@/views/navigation/template/uigb/attest-consultant.vue'
import AttestTravailUigb from '@/views/navigation/template/uigb/attest-travail-uigb.vue'
import CertificatTravail from '@/views/navigation/template/uigb/certificat-travail.vue'
import ConsultantAbsenceNot from '@/views/navigation/template/uigb/consultant-absence-not.vue'
import DomiciliationSalaire from '@/views/navigation/template/uigb/domiciliation-salaire.vue'
import EmployeCertificat from '@/views/navigation/template/uigb/employe-certificat.vue'
import LeaveCertificate from '@/views/navigation/template/uigb/leave-certificate.vue'
import NotifFinContrat from '@/views/navigation/template/uigb/notif-fin-contrat.vue'
import RequestForCert from '@/views/navigation/template/uigb/request-for-cert.vue'
import ResumptionFromLeave from '@/views/navigation/template/uigb/resumption-from-leave.vue'
import SalaryCertificat from '@/views/navigation/template/uigb/salary-certificat.vue'
import SalaryDomiciliation from '@/views/navigation/template/uigb/salary-domiciliation.vue'
import TravelAuth from '@/views/navigation/template/uigb/travel-auth.vue'
import LeaveCertificateValid from '@/views/navigation/template/valide-uigb/leave-certificate-valid.vue';
import AttestCongeValid from '@/views/navigation/template/valide-uigb/attest-conge-valid.vue';
import AttestConsultantValid from '@/views/navigation/template/valide-uigb/attest-consultant-valid.vue';
import AttestTravailUigbValid from '@/views/navigation/template/valide-uigb/attest-travail-uigb-valid.vue';
import CertificatTravailValid from '@/views/navigation/template/valide-uigb/certificat-travail-valid.vue';
import ConsultantAbsenceNotValid from '@/views/navigation/template/valide-uigb/consultant-absence-not-valid.vue';
import DomiciliationSalaireValid from '@/views/navigation/template/valide-uigb/domiciliation-salaire-valid.vue';
import EmployeCertificatValid from '@/views/navigation/template/valide-uigb/employe-certificat-valid.vue';
import NotifFinContratValid from '@/views/navigation/template/valide-uigb/notif-fin-contrat-valid.vue';
import RequestForCertValid from '@/views/navigation/template/valide-uigb/request-for-cert-valid.vue';
import ResumptionFromLeaveValid from '@/views/navigation/template/valide-uigb/resumption-from-leave-valid.vue';
import SalaryCertificatValid from '@/views/navigation/template/valide-uigb/salary-certificat-valid.vue';
import SalaryDomiciliationValid from '@/views/navigation/template/valide-uigb/salary-domiciliation-valid.vue';
import TravelAuthValid from '@/views/navigation/template/valide-uigb/travel-auth-valid.vue';
import CongeView from '@/views/navigation/conge-view.vue';
import MyPreview from '@/views/navigation/my-preview.vue';
import AddNewUser from '@/components/create/add-new-user.vue';
import DepartementCom from '@/views/navigation/ProfileView.vue';
import ColabDetails from '@/views/navigation/colab-details.vue';
import JobView from '@/views/navigation/JobView.vue'
import payrollView from '@/views/navigation/payroll-view.vue'
import UserPermission from '@/views/navigation/user-permission.vue'
import UserExitList from '@/views/navigation/user-exit-list.vue'
import ordreMission from '@/components/create/ordre-mission.vue'

const uigb_link_valid = [
  {
    path: '/my-demande/attest-conge-valid/:id',
    name: 'attest-conge-valid',
    component: AttestCongeValid
  },
  {
    path: '/my-demande/attest-consultant-valid/:id',
    name: 'attest-consultant-valid',
    component: AttestConsultantValid
  },
  {
    path: '/my-demande/attest-travail-uigb-valid/:id',
    name: 'attest-travail-uigb-valid',
    component: AttestTravailUigbValid
  },
  {
    path: '/my-demande/certificat-travail-valid/:id',
    name: 'certificat-travail-valid',
    component: CertificatTravailValid
  },
  {
    path: '/my-demande/consultant-absence-not-valid/:id',
    name: 'consultant-absence-not-valid',
    component: ConsultantAbsenceNotValid
  },
  {
    path: '/my-demande/domiciliation-salaire-valid/:id',
    name: 'domiciliation-salaire-valid',
    component: DomiciliationSalaireValid
  },
  {
    path: '/my-demande/employe-certificat-valid/:id',
    name: 'employe-certificat-valid',
    component: EmployeCertificatValid
  },
  {
    path: '/documents/leave-certificate-valid/:id',
    name: 'leave-certificate-valid',
    component: LeaveCertificateValid
  },
  {
    path: '/my-demande/notif-fin-contrat-valid/:id',
    name: 'notif-fin-contrat-valid',
    component: NotifFinContratValid
  },
  {
    path: '/my-demande/request-for-cert-valid/:id',
    name: 'request-for-cert-valid',
    component: RequestForCertValid
  },
  {
    path: '/my-demande/resumption-from-leave-valid/:id',
    name: 'resumption-from-leave-valid',
    component: ResumptionFromLeaveValid
  },
  {
    path: '/my-demande/salary-certificat-valid/:id',
    name: 'salary-certificat-valid',
    component: SalaryCertificatValid
  },
  {
    path: '/my-demande/salary-domiciliation-valid/:id',
    name: 'salary-domiciliation-valid',
    component: SalaryDomiciliationValid
  },
  {
    path: '/my-demande/travel-auth-valid/:id',
    name: 'travel-auth-valid',
    component: TravelAuthValid
  },
]

const uigb_link = [
  {
    path: '/my-demande/attest-conge',
    name: 'attest-conge',
    component: AttestConge
  },
  {
    path: '/my-demande/attest-consultant',
    name: 'attest-consultant',
    component: AttestConsultant
  },
  {
    path: '/my-demande/attest-travail-uigb',
    name: 'attest-travail-uigb',
    component: AttestTravailUigb
  },
  {
    path: '/my-demande/certificat-travail',
    name: 'certificat-travail',
    component: CertificatTravail
  },
  {
    path: '/my-demande/consultant-absence-not',
    name: 'consultant-absence-not',
    component: ConsultantAbsenceNot
  },
  {
    path: '/my-demande/domiciliation-salaire',
    name: 'domiciliation-salaire',
    component: DomiciliationSalaire
  },
  {
    path: '/my-demande/employe-certificat',
    name: 'employe-certificat',
    component: EmployeCertificat
  },
  {
    path: '/my-demande/leave-certificate',
    name: 'leave-certificate',
    component: LeaveCertificate
  },
  {
    path: '/my-demande/notif-fin-contrat',
    name: 'notif-fin-contrat',
    component: NotifFinContrat
  },
  {
    path: '/my-demande/request-for-cert',
    name: 'request-for-cert',
    component: RequestForCert
  },
  {
    path: '/my-demande/resumption-from-leave',
    name: 'resumption-from-leave',
    component: ResumptionFromLeave
  },
  {
    path: '/my-demande/salary-certificat',
    name: 'salary-certificat',
    component: SalaryCertificat
  },
  {
    path: '/my-demande/salary-domiciliation',
    name: 'salary-domiciliation',
    component: SalaryDomiciliation
  },
  {
    path: '/my-demande/travel-auth',
    name: 'travel-auth',
    component: TravelAuth
  },
]

const routes = [
  {
    path: '/signin',
    name: 'signin',
    meta : {requiresUnAuth : true},
    component: SigninView
  },
  {
    path : '/reset-password',
    name : 'reset-password',
    meta : {requiresUnAuth : true},
    component: ResetPassword
  },
  {
    path:"/",
    component: HomePage,
    meta : {requiresAuth : true},
    children: [
      {
        path: '/',
        component: DashboardView
      },
      {
        path: '/my-exceptions',
        name: 'my-exceptions',
        component: MyException
      },
      {
        path: '/conge',
        name: 'conge',
        component: CongeView
      },
      {
        path: '/my-permissions',
        name: 'my-permissions',
        component: MyPermission
      },
      {
        path: '/my-demande',
        name: 'my-demande',
        component: MyDemande
      },
      {
        path: '/list-exit',
        name: 'list-exit',
        component: UserExitList
      },
      {
        path: '/offer',
        name: 'offer',
        component: JobView
      },
      {
        path: '/my-preview',
        name: 'my-preview',
        component: MyPreview
      },
      {
        path: '/payroll',
        name: 'payroll',
        component: payrollView
      },
      // partie d'UIGB
      ...uigb_link,
      // fin
      ...uigb_link_valid,
      {
        path: '/my-demande/attestation-depart-conge-maternite',
        name: 'attestation-depart-conge-maternite',
        component: AttestDepartCongeMat
      },
      {
        path: '/my-demande/attestation-stage',
        name: 'attestation-stage',
        component: AttestStage
      },
      {
        path: '/my-demande/attestation-travail',
        name: 'attestation-travail',
        component: AttestTravail
      },
      {
        path: '/my-demande/demande-conge',
        name: 'demande-conge',
        component: DemandeConge
      },
      {
        path:"/my-profile",
        name:"my-profile",
        component: ProfileVue
      },
      {
        path: '/my-teams',
        name: 'my-teams',
        component: MyTeam
      },
      {
        path: '/motifs',
        name: 'motifs',
        component: MotifView
      },
      {
        path: '/task',
        name: 'task',
        component: TaskView
      },
      {
        path: '/task/create',
        name: 'create-task',
        component: CreateTaskView
      },
      {
        path: 'task/:taskId/:percentage',
        name: 'task-detail',
        component: UpdateTaskView
      },
      {
        path:'my-teams/:name/:teamId',
        name:'details-my-team',
        component:DetailsMyTeam
      },
      {
        path: '/presences',
        name: 'presences',
        component: PresenceView
      },
      {
        path: '/hr-review',
        name: 'hr-review',
        component: HrReview
      },

      {
        path: '/hr-review/:id',
        name: 'detail-hr-review',
        component: DetailHrReview
      },
      {
        path: '/access',
        name: 'access',
        component: AccessView
      },
      {
        path: '/new-user',
        name: 'new-user',
        component: AddNewUser
      },
      {
        path: '/exceptions',
        name: 'exceptions',
        component: ExceptionView
      },
      {
        path: '/departements',
        name: 'departement',
        component: DepartementCom
      },
      {
        path: '/requetes',
        name: 'requetes',
        component: RequestView
      },
      {
        path: '/documents',
        name: 'documents',
        component: DocumentUi
      },
      {
        path: '/my-perms',
        name: 'my-perms',
        component: UserPermission
      },
      {
        path: '/employes',
        name: 'employes',
        component: EmployeeView
      },
      {
        path:'employes/:userId',
        name:'details-my-employe',
        component:ColabDetails
      },
      {
        path: '/profils',
        name: 'profils',
        component: DepartementView
      },
      {
        path: '/shifts',
        name: 'shifts',
        component: ShiftsView
      },
      {
        path: '/zonesautorisees',
        name: 'zones',
        component: ZonesView
      },
      {
        path: '/joursautorises',
        name: 'days',
        component: DaysView
      },
    ]
  },
  {
    path: "/ordre-mission",
    name : 'ordre-mission',
    component: ordreMission,
    meta : {requiresAuth : true},
  },
  {
    path: '/:catchAll(.*)',
    component: ErrorView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkExactActiveClass : "active-nav-link",
})

router.beforeEach(function(to,_,next){
 if(to.meta.requiresAuth && !store.getters.isAuthenticated){
   next("/signin");
 }else if(to.meta.requiresUnAuth && store.getters.isAuthenticated){
   next("/");
 }else{
   next();
 }
});

export default router
